import AsanConfirmation from './AsanConfirmation';

export default AsanConfirmation;
